// FAQ data for pricing page
export const faqData = [
  {
    question: "Does Lifely store seed phrases or passwords?",
    answer: "No. Lifely never stores passwords, seed phrases, private keys, or sensitive credentials. You can note where these are managed (e.g. '1Password') without storing the actual secrets.",
  },
  {
    question: "Is Lifely a will or legal service?",
    answer: "No. Lifely complements your formal documents by capturing the living context that changes more often than a will. It's an orientation tool, not a legal instrument.",
  },
  {
    question: "Does Lifely custody crypto?",
    answer: "No. Lifely does not hold, manage, or transact any cryptocurrency. It helps you map what exists and how access is managed.",
  },
  {
    question: "Can I export my maps?",
    answer: "Yes. Lifely Standard and Plus include printable summaries that you can print or save as PDF for offline reference.",
  },
];
